// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { Vector3 } from './vector3';


export class Spline {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
__init(i:number, bb:flatbuffers.ByteBuffer):Spline {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsSpline(bb:flatbuffers.ByteBuffer, obj?:Spline):Spline {
  return (obj || new Spline()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsSpline(bb:flatbuffers.ByteBuffer, obj?:Spline):Spline {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Spline()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

guid():string|null
guid(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
guid(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

imageGuid():string|null
imageGuid(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
imageGuid(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

label():string|null
label(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
label(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

color():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

isVisible():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

basePoints(index: number, obj?:Vector3):Vector3|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? (obj || new Vector3()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 24, this.bb!) : null;
}

basePointsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

geometryPoints(index: number, obj?:Vector3):Vector3|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? (obj || new Vector3()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 24, this.bb!) : null;
}

geometryPointsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

isClosed():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

static startSpline(builder:flatbuffers.Builder) {
  builder.startObject(8);
}

static addGuid(builder:flatbuffers.Builder, guidOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, guidOffset, 0);
}

static addImageGuid(builder:flatbuffers.Builder, imageGuidOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, imageGuidOffset, 0);
}

static addLabel(builder:flatbuffers.Builder, labelOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, labelOffset, 0);
}

static addColor(builder:flatbuffers.Builder, color:number) {
  builder.addFieldInt32(3, color, 0);
}

static addIsVisible(builder:flatbuffers.Builder, isVisible:boolean) {
  builder.addFieldInt8(4, +isVisible, +false);
}

static addBasePoints(builder:flatbuffers.Builder, basePointsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, basePointsOffset, 0);
}

static startBasePointsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(24, numElems, 8);
}

static addGeometryPoints(builder:flatbuffers.Builder, geometryPointsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, geometryPointsOffset, 0);
}

static startGeometryPointsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(24, numElems, 8);
}

static addIsClosed(builder:flatbuffers.Builder, isClosed:boolean) {
  builder.addFieldInt8(7, +isClosed, +false);
}

static endSpline(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createSpline(builder:flatbuffers.Builder, guidOffset:flatbuffers.Offset, imageGuidOffset:flatbuffers.Offset, labelOffset:flatbuffers.Offset, color:number, isVisible:boolean, basePointsOffset:flatbuffers.Offset, geometryPointsOffset:flatbuffers.Offset, isClosed:boolean):flatbuffers.Offset {
  Spline.startSpline(builder);
  Spline.addGuid(builder, guidOffset);
  Spline.addImageGuid(builder, imageGuidOffset);
  Spline.addLabel(builder, labelOffset);
  Spline.addColor(builder, color);
  Spline.addIsVisible(builder, isVisible);
  Spline.addBasePoints(builder, basePointsOffset);
  Spline.addGeometryPoints(builder, geometryPointsOffset);
  Spline.addIsClosed(builder, isClosed);
  return Spline.endSpline(builder);
}
}
